export default __webpack_public_path__ + "static/media/become-an-author.70635ba7.png";